import { Directive, Input } from '@angular/core';
import { getDocument } from 'ssr-window';
@Directive({
  selector: '[appFavicon]'
})
export class FaviconDirective {
  @Input() set appFavicon(favicon: string) {
    getDocument().querySelector('link[rel=icon]')?.setAttribute('href', favicon);
  }
}
